import { WizardStepType } from '../types'

export const WizardStepTypeToNumber = (step?: WizardStepType) => {
    switch (step) {
        default:
        case 'SimpleInfo':
            return 0
        case 'ObjectIdentification':
            return 1
        case 'ObjectControl':
            return 2
        case 'OperationGuidelines':
            return 3
        case 'Invoicing':
            return 4
        case 'Summary':
            return 5
        case 'Finish':
            return 6
    }
}
